<bc-header [menuInteraction]="true">
  <bc-header-left logoName="grupo-bancolombia-horizontal" channelName="Validaciones Leasing Bancolombia"></bc-header-left>
  <bc-header-list>
    <app-bcs-divider ></app-bcs-divider>
    <section>
      <div class="bc-px-4 bc-opensans-font-style-2-regular">{{ userName | titlecase }}</div>
    </section>
  </bc-header-list>
</bc-header>
